<template lang="pug">
el-collapse(value="0")
  el-collapse-item(
    :title="title",
    :name="collapsed"
  )
    .body
      slot
</template>
<script>
export default {

  props: {
    title: {
      type: String,
      required: true
    },

    collapsed: {
      type: String,
      default: '0'
    }
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.body {
  padding: 10px;
}
/deep/ .el-collapse-item__header {
  font-size: 16px;
  color: $font-dark-color;
  font-weight: bold;
}

/deep/ .el-collapse-item__content {
  font-size: unset !important;
  color: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AppCollapse.vue